import config from 'config';
import * as types from '../actions/types';
// import { browserHistory } from 'react-router';
import axios from 'axios';
import toastr from 'toastr';
var baseUrl = config.baseUrl;

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
};

export function loginUserSuccess(auth) {
  localStorage.setObject('auth', auth);
  localStorage.setObject('r', 0);
  return {
    type: types.LOGIN_USER_SUCCESS,
    payload: {
      auth
    }
  };
}

export function logoutAndRedirect() {
  const storage = sessionStorage.getItem('emulating') ? sessionStorage : localStorage;
  const runName = storage.getItem('run');
  storage.clear();
  storage.setItem('run', runName);
  return (dispatch) => {
    dispatch(logout());
    return Promise.resolve();
  };
}
export function logout() {
  return {
    type: types.LOGOUT_USER
  };
}

export function putUserToStorage(response) {
  return {
    type: types.PUT_USER_TO_STATE,
    payload: response
  };
}

function validateToken(token, runName) {
  return axios.post(`${baseUrl}/runs/${runName}/validate-dean/`, {}, { headers: { 'ACTIVE-TOKEN': token } });
}

export function loginUser(runName, auth) {
  return (dispatch) => {
    return axios
      .post(baseUrl + '/request-token/', auth)
      .then(async response => {
        if (response.status == 200) {
          try {
            await validateToken(response.data.token, runName).then(() => {
              dispatch(loginUserSuccess(response.data));
              return Promise.resolve();
            });
          } catch (e) {
            throw e;
          }
        }
      })
      .catch(() => Promise.reject());
  };
}

export function resetPassword(obj) {
  return () => {
    let promise = new Promise((resolve, reject) => {
      const config = {
        method: 'POST',
        url: '/reset-password/',
        baseURL: baseUrl,
        data: obj
      };

      axios
        .request(config)
        .then(res => {
          toastr.success('Email sent');
          return resolve(res);
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('Something went wrong');
          return reject();
        });
    });
    return promise;
  };
}

export function sendNewPassword(resetToken) {
  return () => {
    let promise = new Promise((resolve, reject) => {
      const config = {
        method: 'GET',
        url: 'https://api.cognomos.com/reset-password/?reset=' + resetToken
      };
      axios
        .request(config)
        .then(() => {
          return resolve();
        })
        .catch(() => {
          toastr.error('Some problem occurred.');
          return reject();
        });
    });
    return promise;
  };
}



// WEBPACK FOOTER //
// ./src/actions/loginActionCreators.js